import React from 'react';

/**
 * One malformed row should cost you one screen, not the whole app.
 *
 * This exists because a past-due invoice with no failure date threw inside a
 * date calculation and white-screened Billing and the Dashboard together —
 * with nothing rendered, there was no way to even find the bad record.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Nothing collects this yet. Left explicit so it is obvious where a real
    // reporter goes, rather than looking like a swallowed error.
    console.error('[floatdesk] render failed', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="page">
        <section className="panel">
          <header className="panel-head"><h2>This screen could not be displayed</h2></header>
          <div className="panel-body stack">
            <p style={{ margin: 0, color: 'var(--ink-2)' }}>
              Something in this view hit an error. The rest of the app still works, and
              nothing has been lost — your data is exactly as it was.
            </p>
            <pre
              className="mono"
              style={{
                margin: 0, padding: 12, background: 'var(--surface-2)',
                border: '1px solid var(--line)', borderRadius: 'var(--radius)',
                fontSize: 12, overflowX: 'auto', color: 'var(--bad)',
              }}
            >
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <div className="row">
              <button className="primary" onClick={() => this.setState({ error: null })}>
                Try again
              </button>
              <button onClick={() => { window.location.hash = '#/'; this.setState({ error: null }); }}>
                Go to dashboard
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
